import api from './axiosConfig';

export const submitCoupon = async (promoCode: string) => {
  try {
    const response = await api({
      method: 'post',
      url: `/v2/psp/coupon/validate`,
      data: {
        promoCode: promoCode,
      },
    });

    return {
      data: response.data,
      error: false,
    };
  } catch (e) {
    console.error(e);
    return {
      error: true,
    };
  }
};

export const validateReferralCode = async (referralCode: string, email: string) => {
  try {
    const response = await api({
      method: 'post',
      url: `/v2/referral/validate`,
      data: {
        referralCode: referralCode,
        email: email,
      },
    });

    return {
      data: response.data,
      error: false,
    };
  } catch (e) {
    console.error(e);
    return {
      error: true,
    };
  }
};

export const getReferralInfo = async (organizationId: string) => {
  try {
    const response = await api({
      method: 'GET',
      url: `/v2/organization/${organizationId}/referral`,
    });

    return {
      error: false,
      data: response.data,
    };
  } catch (error) {
    console.error('Error fetching referral info:', error.message);
    return {
      error: true,
      data: null,
    };
  }
};
